//------------------------------------------------------------------INITS

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
gsap.registerPlugin(CustomEase);

//------------------------------------------------------------------GLOBAL VARS
var customEase1 = CustomEase.create("custom", "M0,0 C0.05,0.488 0.06,0.674 0.186,0.8 0.318,0.932 0.504,1 1,1");
var customEase2 = CustomEase.create("custom", "M0,0 C0.402,0.016 0.596,0.362 0.72,0.54 0.852,0.73 0.818,1.001 1,1 ");
var customEase3 = CustomEase.create("custom", "M0,0 C0.29,0 0.554,0.456 0.64,0.75 0.708,0.962 0.704,1 1,1 ");
var ww = window.innerWidth;
var wh = window.innerHeight;

var mobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) && (ww < 600);
var tablet = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) && (ww < 913);

var pageID = $('body').attr('data-pageid');
console.log('page anim ID is: ', pageID); 


//----------------------------------------------------------------------------PAGES
//----------------------------------------------------------------------------PAGES
//----------------------------------------------------------------------------PAGES


if(document.body.classList.contains('index')){

	$( ".hpFeatureSection" ).wrapAll( '<div class="hpFeat_mInner" />');
	$( ".hpFeat_mInner" ).wrap( '<div class="hpFeat_mWrapper" />');

	$( ".hpFeatureSection:first-of-type" ).append( '<div class="hpFeatureDivider"></div>');

	var hpLink = $(".hpMainLink").attr("data-link");
	$( ".banner__box" ).wrap( '<a class="hpLinkWrap" href="' + hpLink + '"/>');
 


	$('.hpFeat_mWrapper').append(
		
		'<div class="caroCon">' +
			'<div class="caroSwitch" id="caroSwitch1"></div>' +
			'<div class="caroSwitch" id="caroSwitch2"></div>' +
		'</div>'
	);

	var cPos = 'left';

	$('#caroSwitch2').click((e) => {

		if( cPos=="left" ){
			gsap.to(('.hpFeat_mInner'), 0.88, {xPercent:-50, ease: Power4.easeOut});
			$('#caroSwitch2').css("background-color","var(--darkGreen01)");
			$('#caroSwitch1').css("background-color","unset");
			cPos = 'right';
		}

	});

	$('#caroSwitch1').click((e) => {

		if( cPos=="right" ){
			gsap.to(('.hpFeat_mInner'), 0.88, {xPercent:0, ease: Power4.easeOut});
			$('#caroSwitch1').css("background-color","var(--darkGreen01)");
			$('#caroSwitch2').css("background-color","unset");
			cPos = 'left';
		}

	});
 
	console.log('herrre');

}


if(
document.body.classList.contains('collection-category') ||
document.body.classList.contains('collection-designer') ||
document.body.classList.contains('collection-featured') ||
pageID.includes("featured") ||
document.body.classList.contains('collection') ||
document.body.classList.contains('search')

){

console.log('working here 123');


$(document).click((e) => {
  
  if (!$(e.target).closest('.facets__disclosure').length) {

	$('.facets__disclosure').removeAttr('open');

  }    
});

$('.facets__disclosure').click((e) => {

	console.log('FACET CLICKED');

	$('.facets__disclosure').removeAttr('open');
  
  if ($(e.target).attr('open')) {

	$(e.target).removeAttr('open');

	console.log('was OPEN');

  }  else{
  	console.log('was not open');
  }  
});




}	



if(document.body.classList.contains('collection-featured') ||
	pageID.includes("featured")
	){

	console.log('working here 456');

	var currURL = window.location.href;

	if( (currURL.indexOf("page") > -1) && !(currURL.indexOf("page=1") > -1)  ) {

		$('.bqColumn').css("display", "none");

		console.log('paginated');

	}else{

		$('.bqColumn').css("display", "block");

		console.log('NOT paginated');


	}



	if(!mobile){

		// POTENTIAL TALL IMG CALCULATOR
		var calcIMGHght  = ()=> {

			var oh = $('#ftCollItem-2').outerHeight(true);

			var gr_ht = $('.grid').css("grid-row-gap");
			var gr_ht_p = parseInt(gr_ht);


			var pc_m = $('#ftCollItem-1').css("margin-bottom");
			var pc_m_p = parseInt(pc_m);


			var wv = ww/100;

			var info_ht = $('#ftCollItem-1 .hpcgInfoCon').outerHeight(true);	

			var tallIMG_clip = (oh * 2) - info_ht + gr_ht_p - 1;
			var wideIMG_clip = (oh) - info_ht - 1;

			var tVal = Math.ceil(tallIMG_clip);
			var wVal = Math.ceil(wideIMG_clip);


			$('.ftcl_imgColumn-tall').height(tVal);
			$('.ftcl_imgColumn-wide').height(wVal);


			
			// console.log('outer height: ', oh);
			// console.log('average card info: ', info_ht);
			// console.log('average card info margin: ', pc_m_p);


			console.log('clip tall img at: ', tVal);

			console.log('grid row ht: ', gr_ht);
			console.log('window: ', wv);
		 
		 }	 

		 calcIMGHght();
		

		 window.addEventListener('resize', function (){
		 	calcIMGHght();
		 });






		// console.log('average card 4 item height: ', pc4_ht);
		// console.log('grid gap: ', gg_p);
		// console.log('average card info height: ', pc_info_ht);

		// console.log('clip tall img at: ', tallIMG_clip);


	}


}





//----------------------------------------------------------------------------PRODUCT PAGE/CART
//----------------------------------------------------------------------------PRODUCT PAGE/CART
//----------------------------------------------------------------------------PRODUCT PAGE/CART



if(
document.body.classList.contains('product') || 
document.body.classList.contains('product-product-page-v2')
){

	$('main').append('<div class="sil-Globo-BG"></div>');

	setTimeout(function() {

		$('.gBackInStockBtn').attr("id", "silBackInStockBtn");
		$('#silBackInStockBtn').append('<div class="lLineG"></div');

		$('#silBackInStockBtn').mouseenter(function(){
			var thisLine = $(this).find('.lLineG');
			gsap.to((thisLine), 0.66, {scaleX:1, transformOrigin: "left", ease:Power4.easeOut});
			// console.log('moused');
		});


		$('#silBackInStockBtn').mouseleave(function(){
			var thisLine = $(this).find('.lLineG');
			gsap.to((thisLine), 0.66, {scaleX:0, transformOrigin: "right", ease:Power4.easeOut});
			// console.log('moused');
		});

		$('#silBackInStockBtn').click(function(){

			gsap.to((".sil-Globo-BG"), 1.33, {opacity:1, ease:Power4.easeOut});
  
			setTimeout(function() {

				$('.Globo-header-close').html('<div class="globoCloseCon"><p class="globo-closeText lLine_g">Close &#10005;</p><div class="lLineG"></div></div> ');
				$('.Globo-header-close').attr("id", "silGloboCloser");

				$('.Globo-body-header p, .Globo-footer-message').addClass("bodyCopy globoCopy");

				$('#Globo-Back-In-Stock .Globo-body-content').attr("id", "silGlobo-content");

				$('#Globo-Back-In-Stock .gBackInStock-Form-Control').attr("id", "sil_gBackInStock-Form-Control");

				$('#Globo-Back-In-Stock .gSubscribeBtn').attr("id", "sil_gSubscribeBtn");
	
				$('.Globo-water-mark').attr("style", " ");

				gsap.to(("#Globo-Back-In-Stock .Globo-form"), 0.88, {opacity:1, y:0, ease:Power4.easeOut});


				$('.globoCloseCon').mouseenter(function(){
					var thisLine = $(this).find('.lLineG');
					gsap.to((thisLine), 0.66, {scaleX:1, transformOrigin: "left", ease:Power4.easeOut});
					// console.log('moused');
				});


				$('.globoCloseCon').mouseleave(function(){
					var thisLine = $(this).find('.lLineG');
					gsap.to((thisLine), 0.66, {scaleX:0, transformOrigin: "right", ease:Power4.easeOut});
					// console.log('moused');
				});

				$('#sil_gSubscribeBtn').click(function(){
					setTimeout(function() {
						$('#Globo-Back-In-Stock .gBackInStock-Message-Success').attr("id", "sil_gBackInStock-Message-Success");
						gsap.to(("#Globo-Back-In-Stock .gBackInStock-Message-Success"), 0.33, {opacity:1, ease:Power4.easeOut});
						console.log('subscribe processed.');
					},2000);
				});

				$('.globo-closeText').click(function(){
					gsap.to((".sil-Globo-BG"), 0.33, {opacity:0, ease:Power4.easeOut});
				});

			}, 1000);

		});


	}, 1000);
	

}






if(
document.body.classList.contains('product') || 
document.body.classList.contains('product-product-page-v2')
){


var reLine = ()=> {

	$('.lLine_g, .lLine_g2, .zooomypwishmsg').each(function(){

		$(this).append('<div class="lLineG"></div>');

	});

	$('.lLine_w, .lLine_w2').each(function(){
		$(this).append('<div class="lLineW"></div>');
	});


	$('.lLine_g, .lLine_w, .zooomypwishmsg, .scWrap').mouseenter(function(){
		var thisLine = $(this).find('.lLineG, .lLineW');
		gsap.to((thisLine), 0.66, {scaleX:1, transformOrigin: "left", ease:Power4.easeOut});
		// console.log('moused');
	});


	$('.lLine_g, .lLine_w, .zooomypwishmsg, .scWrap').mouseleave(function(){
		var thisLine = $(this).find('.lLineG, .lLineW');
		gsap.to((thisLine), 0.66, {scaleX:0, transformOrigin: "right", ease:Power4.easeOut});
		// console.log('moused');
	});

	console.log('re-lined************');

}	

// $(".button--primary").click( (e)=> {

// 	setTimeout( ()=> {
// 	$('.cart-count-bubble').addClass('drkBorder drkClr');
// 	reLine();
// 	clearCartProps();
// 	console.log('SET');
	
// 	}, 2000);


// });





//-------------------------------------------------------------BUTTON FUNCTION ADDITIONS
//-------------------------------------------------------------BUTTON FUNCTION ADDITIONS
//-------------------------------------------------------------BUTTON FUNCTION ADDITIONS

console.log('HEREHERE v3'); 

// console.log("product data from js:", productData);
// console.log("variants are:", productData.variants);
// console.log("variant qty is:", productData.variants.inventory_quantity);

var currVar = "";

console.log("quants2", varQtys);

var test1 = ()=> {

	currVar = 1;
	
	console.log('testing global variable... ', window.currVar);
	console.log('testing local variable... ', currVar);

}	


var btnCheck = ()=> {


	console.log('running button check...');

	var t1 = 0.1;
	var t2 = 0.55;

	console.log('currVar inside btnCheck is: ', currVar);

	if (product_type == "mto"){

	  console.log('js product type is: ', product_type);

	  varQtys.forEach((el) => {

	  	// console.log(el[0]);

	  	if(currVar == el[0]){

	  		console.log("matched size is: ", el[0]);

	  		if ((el[1] == "shopify") && (el[2] >= 1)){ //PRODUCT TYPE 02

	  			gsap.to(('.full_mtoBtn span'), t1, {opacity:0, ease:Power4.easeOut});
	  			setTimeout( ()=> {
	  			// $('.full_mtoBtn span').text("Add To Cart (tracked MTO)");
	  			$('.full_mtoBtn span').text("Add To Cart");
	  			$('.full_mtoBtn span').css("color", "var(--white01)");
	  			}, 500);
	  			gsap.to(('.full_mtoBtn span'), t1, {opacity:1, delay: t2, ease:Power4.easeOut});


		  		console.log("MTO w/ inv.");


			  }else{ //PRODUCT TYPE 01 & PRODUCT 02 VARS W/O INV

	  			gsap.to(('.full_mtoBtn span'), t1, {opacity:0, ease:Power4.easeOut});
			  	setTimeout( ()=> {
			  	// $('.full_mtoBtn span').text("Made-To-Order (not tracked MTO)");
			  	$('.full_mtoBtn span').text("Made-To-Order");
			  	$('.full_mtoBtn span').css("color", "var(--white01)");
			  	}, 500);
	  			gsap.to(('.full_mtoBtn span'), t1, {opacity:1, delay: t2, ease:Power4.easeOut});
	  	
		  		console.log("MTO items w/o inv");

			  }

	  	}

	   
	  });
		  

	}else if (product_type == "std"){

	  console.log('js product type is: ', product_type);

	  varQtys.forEach((el) => {

	  	if(currVar == el[0]){ //PRODUCT TYPE 03

	  		console.log("matched size is: ", el[0]);

	  		  if ((el[3] == "continue") && (el[2] <= 0)){

	  				gsap.to(('.full_addToCartBtn span'), t1, {opacity:0, ease:Power4.easeOut});
	  		  	setTimeout( ()=> {
	  		  	$('.full_addToCartBtn span').text("Made-To-Order");
	  		  	$('.full_addToCartBtn span').css("color", "var(--white01)");
	  		  	}, 500);
	  				gsap.to(('.full_addToCartBtn span'), t1, {opacity:1, delay: t2, ease:Power4.easeOut});

	  		  }else{ //PRODUCT TYPE 04
		  		  
		  		  console.log('STD product w/ MTO after 0.');

	  		  }

	  	}

	  });	

	  



	}else{
	  console.log('js product type is: else std');
	}


}	

var currVar = "";
var opts = [];



var firstVar = ()=> {

	console.log($('.variantOptsField').length);

	$('.variantOptsField').each( (i) => {

		var theseOpts = $(this).find('.varInput');

		theseOpts.each((el) => {

			if ($(this).attr( "checked" )){
				var checkedOpt = $(this).attr("value");
				opts.push(checkedOpt);

				console.log('found checked opt:', checkedOpt);

			}else{
				console.log('STIIIILL LOOKING...');
			}


		});

			
	});
	console.log('fields:::::::', opts);
	optString = opts.toString();
	currVar = optString.replace(/[( ,/.)]/g, "");
	console.log('FIRST VAR IS:::::', currVar);




}

 firstVar();
 btnCheck();



$(".varInput").click( (e)=> {

	var currField = $(this).parent();
	var currFieldVal = currField.attr('data-fieldnum');
	console.log('CLICKED FIELD ISSS:::::', currFieldVal);

	clickedVar = $(this).attr("value");

	opts[currFieldVal] = clickedVar;
	optString = opts.toString();
	currVar = optString.replace(/[() ,/.)]/g, "");

	console.log('CURR VAR AFTER CLICK::::', currVar);


	btnCheck();
	
	
});



//-------------------------------------------------------------BUTTON FUNCTION ADDITIONS END 
//-------------------------------------------------------------BUTTON FUNCTION ADDITIONS END 
//-------------------------------------------------------------BUTTON FUNCTION ADDITIONS END








var srcCheck = $('.scIMG').attr('src');
// console.log(srcCheck);

if(srcCheck.indexOf("no-image") > -1) {
	// console.log('THERES NO IMAGE');
}else{
	// console.log('theres an img here');

	$('.product__description').append(
		'<div class="scWrap">' +
			'<a class="sizeLink" href="#size-chart">Size Chart</a>' +
			
		'</div>'
	);

	$('.scWrap').mouseenter(function(){
		var thisLine = $(this).find('.lLineG, .lLineW');
		gsap.to((thisLine), 0.66, {scaleX:1, transformOrigin: "left", ease:Power4.easeOut});
	});

	$('.scWrap').mouseleave(function(){
		var thisLine = $(this).find('.lLineG, .lLineW');
		gsap.to((thisLine), 0.66, {scaleX:0, transformOrigin: "right", ease:Power4.easeOut});
		// console.log('moused it');
	});


	$('a[href="#size-chart"]').click( ()=> {

		gsap.to(('.sizeChartSection'), 0.66, {opacity:1, zIndex:"1000", ease:Power4.easeOut});
		gsap.from(('.scIMGCon'), 0.66, {opacity:0, y:40, delay:0.2, ease:Power4.easeOut});

	}); 

	$('.closeCon_sc, .sizeChartBG').click( ()=> {

		gsap.to(('.sizeChartSection'), 0.66, {opacity:0, zIndex:"-1", ease:Power4.easeOut});
		gsap.to(('.scIMGCon'), 0.66, {opacity:0, y:40, clearProps:"all", ease:Power4.easeOut});

	});
}





$('#ZlistWishlist').click( ()=> {
	gsap.fromTo(".zooomyloginrequest", {opacity: 0}, {opacity: 1, duration: 1});
	console.log('clicked the thing');
});



var prodInfo_ht = $('.productInfoWrapper').outerHeight();
// console.log('product info height is: ', prodInfo_ht);

if(prodInfo_ht > wh){

	// console.log('window height is: ', wh);
	$('.productInfoWrapper').css("padding-top", "200px");

	// console.log('extra padding added');
}



//-------info pin control

	if(document.body.classList.contains('product')){

		// var pin1;
		var initPin = ()=> {

			var pinMeasure = wh * 0.6;
			var proInfoHght = $('.productInfoWrapper_v2 .productInfoContainer').innerHeight();

			if(proInfoHght >= pinMeasure){
				if(!mobile){
					ScrollTrigger.create({
					trigger:".productMediaWrapper",
					start:"top top",
					end:"bottom bottom",
					endTrigger:".productMediaWrapper",
					anticipatePin: 0.5,
					pin:".productInfoContainer",
					pinSpacing:true,
					id:"pin1"
					// markers:true
					});
				}
				// console.log('pinning v2 PS true...', proInfoHght, pinMeasure);
			}else{
				if(!mobile){
					ScrollTrigger.create({
					trigger:".productMediaWrapper",
					start:"top top",
					end:"bottom bottom",
					endTrigger:".productMediaWrapper",
					anticipatePin: 0.5,
					pin:".productInfoContainer",
					pinSpacing:false,
					id:"pin1"
					// markers:true
					});
				}
				// console.log('pinning v2 ps false...', proInfoHght, pinMeasure);
			}

			

			

			// return pin1 = gsap.getById("pin1");

		}	

	}else{

		// var pin1;
		var initPin = ()=> {

			if(!mobile){
				ScrollTrigger.create({
				trigger:".productInfoWrapper",
				start:"top top",
				end:"bottom bottom",
				endTrigger:".productInfoWrapper",
				anticipatePin: 0.5,
				pin:".productMediaWrapper",
				pinSpacing:false,
				id:"pin1"
				// markers:true
				});
			}

			// console.log('pinning else...');

			// return pin1 = gsap.getById("pin1");

		}	
	}




initPin();


//-------gallery zoom
sw = 0;

if(!tablet){

	//-------gallery 1.0

	$(".silGalleryWrapper").click(function() {

		if(sw == 0){

			ScrollTrigger.getById("pin1").disable(true);


			$('.silProduct').addClass('silProduct-zoom');
			$('.silGalleryWrapper').addClass('icon-minus');
			$('.productInfoWrapper').css('display', 'none');

			gsap.to(('.silGalleryWrapper'), 0.0, {x:0, ease: Power4.easeOut});

			$('.productMediaWrapper').css("overflow", "unset");
			$('.productMediaWrapper').css("height", "auto");
			$('.productMediaWrapper').css("justify-content", "center");
			$('.silGalleryWrapper').css("flex-direction", "column");
			$('.productIMG').css("margin", "0 0 2px 0");
			$('.productIMG').css("width", "100%");
			$('.productIMG').css("height", "auto");
			$('.imgGalArrow').css("display", "none");			
			

			// ScrollTrigger.create({
		 //    trigger:".silGalleryWrapper",
		 //    start:"top top",
		 //    end:"bottom bottom",
		 //    endTrigger:".silGalleryWrapper",
		 //    // anticipatePin: 0.5,
		 //    pin:".productInfoWrapper",
		 //    pinSpacing:false
		 //    // markers:true
			//   });

			sw++;

		}else{

			$('.silProduct').removeClass('silProduct-zoom');
			$('.silGalleryWrapper').removeClass('icon-minus');
			$('.productInfoWrapper').css('display', 'flex');

			$('.productMediaWrapper').css("overflow", "hidden");
			$('.productMediaWrapper').css("height", "100vh");
			$('.productMediaWrapper').css("justify-content", "flex-start");
			$('.silGalleryWrapper').css("flex-direction", "row");
			$('.productIMG').css("margin", "0 2px 0 0");
			$('.productIMG').css("width", "auto");
			$('.productIMG').css("height", "100%");
			$('.imgGalArrow').css("display", "block");

			// ScrollTrigger.killAll();

			sw=0;

			ScrollTrigger.getById("pin1").enable(true);



		}

		// console.log(sw);
		
	});


	//-------gallery 2.0

	$(".carouselStage").click(function() {

		if(sw == 0){

			ScrollTrigger.getById("pin1").disable(true);

			$('.silProduct, .thumbnailCarousel, .thumbnailCaroMain').addClass('silProduct-zoomed');
			$('.thumbnailCaroMain').addClass('thumbnailCaroMain-zoomed');
			$('.carouselStage').addClass('icon-minus');

			$('.productInfoWrapper, .thumbnailsWrapper').css('display', 'none');

			$('.carouselStage').addClass('unsetHght');
			$('.productIMG').addClass('productIMG-zoomed');

			sw++;

		}else{

			$('.silProduct, .thumbnailCarousel, .thumbnailCaroMain').removeClass('silProduct-zoomed');
			$('.thumbnailCaroMain').removeClass('thumbnailCaroMain-zoomed');
			$('.carouselStage').removeClass('icon-minus');

			$('.productInfoWrapper, .thumbnailsWrapper').css('display', 'flex');

			$('.carouselStage').removeClass('unsetHght');
			$('.productIMG').removeClass('productIMG-zoomed');

		

			sw=0;

			ScrollTrigger.getById("pin1").enable(true);



		}

		// console.log(sw);
		
	});

}

//-------gallery slide
//-------gallery slide
//-------gallery slide


var galType = $('.silProduct').attr("data-gallayout");


if(galType=="thumbnail_slider"){

	// console.log('gallery type : ', galType);


	//-------set wrappers/imgs to correct height

	var setThWrapperHght = ()=> {
		var galHght = $('.thumbnailCaroMain').height();
		// console.log('gallery galHeight : ', galHght);
		$('.carouselStage').css("height", galHght);
		$('.thumbnailsWrapper').css("height", galHght);
	}	
	setThWrapperHght();

	window.addEventListener('resize', function (){
		setThWrapperHght();
	});


	//-------thumbnail menu functionality

	var nextTh;
	var toTh_TB;
	var currStageIMG = 1;

	var scrollSpeed = 0.44;
	var cooler = 0;

	var thTotal = $('.indThumbCon').length;
	var thCntr = 0;

	var thWrprHght = $('.thumbnailsWrapper').height();
	var thConHght = $('.caroThumbnailCon').height();
	
	var wrprTB = $('.thumbnailsWrapper').offset().top;
	var wrprBB = $('.thumbnailsWrapper')[0].getBoundingClientRect().bottom;

	var lastTh_BB = $('.indThumbCon:last-of-type')[0].getBoundingClientRect().bottom;

	$('.indThumbCon:first-of-type').addClass("indThumbCon_active");


	//---thumbnail menu scrolling

	var activateThNav = ()=> {

		//---measuring/find last thumbnail relative to viewable window
		var bbTh;
		// console.log('container bottom bound is: ', wrprBB);

		$('.indThumbCon').each(function(){

			var thBB = $(this)[0].getBoundingClientRect().bottom;
			// console.log('bottom bound is: ', thBB);	


			if(thBB >= wrprBB){
				bbTh = $(this).attr("data-thumbnail");
				// console.log('bottom thumbnail: ', bbTh);	
				return false;
			}
			
		});

		var thLastVal = thTotal - bbTh;
		// console.log('stpper val will be: ', thLastVal);


		//----arrow stuff
		var checkUpArrow = ()=> {
			if(!( thCntr == 0)){
				$('#imgGalArrow_up').addClass("arrow_on");
				gsap.to(('#imgGalArrow_up'), 0.22, {opacity:0.66, ease: Power4.easeOut});
			}else{
				$('#imgGalArrow_up').removeClass("arrow_on");
				gsap.to(('#imgGalArrow_up'), 0.22, {opacity:0.33, ease: Power4.easeOut});
			}
			// console.log('checked up arrow');
		}	

		var checkDownArrow = ()=> {
			if(!( thCntr == thLastVal)){
				$('#imgGalArrow_down').addClass('arrow_on');
				gsap.to(('#imgGalArrow_down'), 0.22, {opacity:1, ease: Power4.easeOut});
			}else{
				$('#imgGalArrow_down').removeClass('arrow_on');
				gsap.to(('#imgGalArrow_down'), 0.22, {opacity:0.33, ease: Power4.easeOut});
			}
			// console.log('checked down arrow');
		}	

		//----overscroll compensation
		var evenOutBottom = ()=> {

			setTimeout(function() {

				console.log('evening out bottom... 5');
				wrprBB = $('.thumbnailsWrapper')[0].getBoundingClientRect().bottom;
				toTh_BB = $('.indThumbCon:last-of-type')[0].getBoundingClientRect().bottom;

				if(!(toTh_BB==wrprBB)){
					var compDist = wrprBB - toTh_BB;
						gsap.to(('.caroThumbnailCon'), 0.33, {y:"+=" + compDist, ease: Power4.easeOut});

						// console.log('con bottom boundary: ', wrprBB);
						// console.log('Last Th bottom boundary: ', toTh_BB);
						// console.log('Distance: ', compDist);

				}

			},300);		
		}	

		var evenOutTop = ()=> {

			setTimeout(function() {

				console.log('evening out top...');
			  wrprTB = $('.thumbnailsWrapper').offset().top;
				toTh_TB = $('.indThumbCon:first-of-type')[0].getBoundingClientRect().top;

				if(!(toTh_TB==wrprTB)){
					var compDist = toTh_TB - wrprTB;
						gsap.to(('.caroThumbnailCon'), 0.33, {y:"+=" + compDist, ease: Power4.easeOut});

						// console.log('con top boundary: ', wrprTB);
						// console.log('First Th top boundary: ', toTh_TB);
						// console.log('Distance: ', compDist);

				}
			},300);		
		}	


		$("#imgGalArrow_down").click( (e)=> {

				if(thCntr == (thLastVal-1)){

					thCntr++;

					toTh_BB = $('.indThumbCon:last-of-type')[0].getBoundingClientRect().bottom;
					var tDist = wrprBB - toTh_BB;
					gsap.to(('.caroThumbnailCon'), scrollSpeed, {y:"+=" + tDist, ease: Power4.easeOut, onComplete:evenOutBottom});

					// console.log('reached the end.');

					checkDownArrow();	

					// console.log('thCon bottom boundary: ', toTh_BB);
					// console.log('Next Th bottom boundary: ', toTh_TB);
					// console.log('Distance: ', tDist);

				}else if(!(thCntr >= thLastVal)){

					thCntr++;

					nextTh = thCntr + 1;
					toTh_TB = $('#indThumbCon_' + nextTh).offset().top;

					var tDist = toTh_TB - wrprTB;

					gsap.to(('.caroThumbnailCon'), scrollSpeed, {y:"-=" + tDist, ease: Power4.easeOut});
					
					checkUpArrow();
					
					// thCntr = (thLastVal-1);

				}else{
					// setTimeout(evenOutBottom, 1000);
					// console.log('reached the end. (else)');
				}

				// console.log(thCntr);
			

		});



		$("#imgGalArrow_up").click( ()=> {


				thCntr--;

				nextTh = thCntr + 1;
				toTh_TB = $('#indThumbCon_' + nextTh).offset().top;

				var tDist = toTh_TB - wrprTB;

				// console.log('thCon boundary: ', wrprTB);
				// console.log('Next Th top boundary: ', toTh_TB);
				// console.log('Distance: ', tDist);

				gsap.to(('.caroThumbnailCon'), scrollSpeed, {y:"-=" + tDist, ease: Power4.easeOut});

				if(thCntr == 0){
					evenOutTop();
				}

				//---up arrow stuff
				checkUpArrow();
				checkDownArrow();

		

			// console.log(thCntr);
			
		});

	}	


	activateThNav();
	// if(thConHght > thWrprHght){
	// 	activateThNav();
	// 	console.log('th nav active');
	// }else{
	// 	// $('.thumbnailCarousel .imgGalArrow').css("display", "none");
	// 	console.log('th nav NOT active');
	// }
	
	//---thumbnail menu selecting

		$(".indThumbCon").click(function(){

			var currTh = $(this).attr("data-thumbnail");
			
			if(!(currTh == currStageIMG)){
				gsap.to(('.productIMG'), 0.88, {opacity:0, ease: Power4.easeOut});
				gsap.to(('#productImage_' + currTh), 0.88, {opacity:1, ease: Power4.easeOut});
				
				gsap.to(('.indThumbCon .productThumbnail'), 0.22, {opacity:0.66, ease: Power4.easeOut});
				gsap.to(('#indThumbCon_' + currTh + ' .productThumbnail'), 0.22, {opacity:1, ease: Power4.easeOut});

				$('.indThumbCon').removeClass('indThumbCon_active');
				$('#indThumbCon_' + currTh).addClass('indThumbCon_active');

				currStageIMG = currTh;
				console.log("oooon stage: ", currStageIMG);
			}else{
				console.log('same one.');
			}

		});



}else{


	var sl_L = $('.productIMG').length;
	// console.log('product length: ', sl_L);

	var allWidths = 0;

	$('.productIMG').each(function(){
		var imgWidth = $(this).outerWidth();
		allWidths += imgWidth;
	});

	// console.log('final width: ', allWidths);

	// var tDist = (allWidths / sl_L) * 0.9;

	var nextIMG;
	var toIMG_LB;

	var conLB = $('.productMediaWrapper media-gallery').offset().left;
	var imgLB = $('#productImage_2').offset().left;

	// console.log("img bound: ", imgLB);
	// console.log("con LB: ", conLB);outh



	var clcntr = 0;

	$("#imgGalArrow_right").click( ()=> {

		if(!( clcntr >= sl_L)){

			clcntr++;

			nextIMG = clcntr + 1;
			toIMG_LB = $('#productImage_' + nextIMG).offset().left;

			var tDist = toIMG_LB - conLB;
			console.log("t dist: ", tDist);

			gsap.to(('.silGalleryWrapper'), 0.8, {x:"-=" + tDist, ease: Power4.easeOut});

			$('.imgGalArrow_left').addClass('arrow_on');

			if((clcntr + 1) == sl_L){
			$('.imgGalArrow_right').removeClass('arrow_on');
			console.log('boop');
			}

			
		}else{
			clcntr= (sl_L-1);
			console.log('END REACHED');

			$('.imgGalArrow_right').removeClass('arrow_on');
			console.log('arrow off');
		}

		console.log(clcntr);

	});


	$("#imgGalArrow_left").click( ()=> {

		if(!( 0 >= clcntr)){

			clcntr--;

			nextIMG = clcntr + 1;
			toIMG_LB = $('#productImage_' + nextIMG).offset().left;
			var tDist =  conLB - toIMG_LB;
			console.log("cuurrIMG: ", $('#productImage_' + nextIMG));
			console.log("t dist: ", tDist);

			gsap.to(('.silGalleryWrapper'), 0.8, {x:"+=" + tDist, ease: Power4.easeOut});

			$('.imgGalArrow_right').addClass('arrow_on');


			if(clcntr==0){
			$('.imgGalArrow_left').removeClass('arrow_on');
			}
			
		}else{
			clcntr=0;
			console.log('BEGINNING REACHED');
			$('.imgGalArrow_left').removeClass('arrow_on');
		}

		console.log(clcntr);

	});



}






}



if(document.body.classList.contains('page-zooomywishlist')){


}





if(document.body.classList.contains('page-about')){


//-------info pin control

if(!mobile && ww > 913){
	ScrollTrigger.create({
	trigger:".abCopyCon",
	start:"top top",
	end:"bottom bottom",
	endTrigger:".abCopyCon",
	anticipatePin: 0.5,
	pin:".abIMGCon",
	pinSpacing:false
	// markers:true
	});

	console.log('pinning');
}



} 








//----------------------------------------------DESIGNERS

if(document.body.classList.contains('page-designers')){

	var dlHt = $('.dlinkList').outerHeight();
	var thresh1 = dlHt * 0.77;

	console.log("List height: ", dlHt); 

	if(dlHt > thresh1){

		gsap.to(".dlinkList", {
		  scrollTrigger: {
		  	trigger:".designerSection",
		  	toggleActions:"play reverse",
		  	start:"top top",
		  	end:"bottom top",
		  	scrub:true
		  	// markers:true
		  },
		  yPercent:-33
		});


		console.log('greater than');

	}else{
		console.log('less than');
	}

	var prevDesID;
	var currDesID;

	var listLength = $(".desItem").length;
	$('.desCounter').text(listLength + " Designers");


if(!mobile){

	$('#dprofile-1').addClass('desIn');	
	$('.desItem:first-of-type').addClass('desItem-active');
	$('.desItem:nth-of-type(1) .lLine_g2').addClass('LineOut');	

	console.log('designers: ', listLength);



	ScrollTrigger.create({
		trigger:"main",
		start:"top top",
		end:"bottom bottom",
		endTrigger:".designerProfileCon",
		pin:".desTitleBlock",
		anticipatePin: 1,
		pinSpacing:false
		// markers:true
	});

	ScrollTrigger.create({
		trigger:"main",
		start:"top top",
		end:"bottom bottom",
		endTrigger:"main",
		pin:".dlinkList",
		anticipatePin: 1,
		pinSpacing:false
		// markers:true
	}); 


	var i1 = 1;

	var cycleDown = ()=> {

		i1--;

		if(1 >= i1){
			i1=1;
		}

		$('.desItem').removeClass('desItem-active');
		$('.desItem:nth-of-type(' + i1 + ')').addClass('desItem-active');

		$('.desItem .lLine_g2').removeClass('LineOut');
		$('.desItem:nth-of-type(' + i1 + ') .lLine_g2').addClass('LineOut');


		console.log(i1, 'CYCLED DOWN');

	}

	var cycleUp = ()=> {

		i1++;

		if(i1 >= listLength){
			i1=listLength;
		}

		$('.desItem').removeClass('desItem-active');
		$('.desItem:nth-of-type(' + i1 + ')').addClass('desItem-active');

		$('.desItem .lLine_g2').removeClass('LineOut');
		$('.desItem:nth-of-type(' + i1 + ') .lLine_g2').addClass('LineOut');


		console.log(i1, 'CYCLED UP');

	}


	$('.desIndProfCon').each(function(){

		// $(this).addClass('desItem-active');

		var profInOut = gsap.timeline();
		profInOut
			.to($(this), 0.11, {opacity:1, ease: "none", onReverseComplete:cycleDown})
			.to($(this), 1, {opacity:1, ease: "none"})
			.to($(this), 0.1, {opacity:1, ease: "none", onComplete:cycleUp})
		;

		ScrollTrigger.create({
			animation:profInOut,
			trigger:$(this),
			start:"top +=15%",
			end:"bottom +=20%",
			endTrigger:$(this),
			toggleActions:"play reverse play reverse",
			scrub:true
			// markers:true
		});


	});


	var desTitle_H = $('.desTitleBlock').height();
	var offsetVal = desTitle_H * 1.14;
	console.log('offset val is: ', offsetVal);

	$(".desItem").click(function() {

		var nextItemId = $(this).attr('data-dlink');
		var nextItem = '#dprofile-' + nextItemId;

		console.log(nextItem);


		gsap.to(window, {duration: 1.33, scrollTo: {y: nextItem, offsetY: offsetVal}, ease: customEase3});


		// gsap.to(window, 1.33, {scrollTo:{y:"#dprofile-5"}, ease: Power4.easeOut});

	});	


}else{


	$(".desIndTitle").click(function(){

		var currDesID = $(this).parent().attr('id');
		var currDes = $("#" + currDesID);

		console.log("current", currDesID);
		console.log("previous", prevDesID);

		$(this).addClass('desIndTitle_active');
		currDes.addClass("desOpen");

		if(currDesID!=prevDesID){

			console.log('sw 1');
		
			gsap.to((currDes), 1, {height:"auto", ease: Power4.easeOut});

			prevDesID=currDesID;

		}else{

			console.log('sw 2');

			gsap.to((currDes), 1, {height:"35px", ease: Power4.easeOut});
			$(this).removeClass('desIndTitle_active');
			currDes.removeClass("desOpen");



			prevDesID=0;

		}

		

		// console.log(currDes);


	});






}


// 	// ScrollTrigger.create({
// 	// 	// animation:profInOut,
// 	// 	trigger:".designerProfileCon",
// 	// 	start:"top top",
// 	// 	end:"bottom bottom",
// 	// 	endTrigger: $(this),
// 	// 	// toggleActions:"play reverse play reverse",
// 	// 	pin:$(this),
// 	// 	// scrub:true
// 	// 	// pin:true,
// 	// 	// pinSpacing:false,
// 	// 	// anticipatePin: 1,
// 	// 	markers:true
// 	// });



//---------------CLICK TO

// $(".desItem").click( ()=> {

// 	$('.desIndProfCon').removeClass('desIn');

// 	var currItem = $(this).attr('data-dlink');

// 	$('#dprofile-' + currItem).addClass('desIn');


// });






}




//----------------------------------------------PRESS


if(document.body.classList.contains('page-press')){

$('#dprofile-1').addClass('desIn');	

var articleLength = $(".pressBlock").length;

$('.featureTitle').text(articleLength + " Features");


console.log('articles: ', articleLength);


$(".pressGrid").hover( ()=> {

	$(".pressGrid .pressBlock").toggleClass("op5");

	console.log('HOVERING...');

});


}


//----------------------------------------------POLICIES


if(document.body.classList.contains('page-policies')){


// var ph1 = $(".policySection:nth-of-type(1) .polCol_info").innerHeight();
// var ph2 = $(".policySection:nth-of-type(2) .polCol_info").innerHeight();

// $(".policySection:nth-of-type(1) .policyConSection").innerHeight(ph1);
// $(".policySection:nth-of-type(2) .policyConSection").innerHeight(ph2);

// console.log('height 1: ', ph1);
// console.log('height 2: ', ph2);




var fromURL = window.location.href;
var prevPolID;
var currPolID;

console.log('URL: ', fromURL);


if(window.location.href.indexOf("privacy") > -1) {


	if(!mobile){

		console.log('here for privacy');


		$(".policySection:nth-of-type(2) .polTitle").addClass('o100');
		$(".policySection:nth-of-type(2) .polCol_info").addClass('o100');	

		setTimeout(function(){
			var ph = $(".policySection:nth-of-type(2)").outerHeight(true);
			// var ph2 = ph * 1.05;
			$(".page-policies main").height(ph);
			console.log('height 1: ', ph);
		}, 300);//for some reason, doesn't calculate full height without slight time offset


		

	}else{

		var childBlock = $("#PrivacyPolicy").nextAll('.polBlock');


		$("#PrivacyPolicy").addClass('polBlock_open');
		gsap.to((childBlock), 0.99, {height:"auto", ease: Power4.easeOut});

		$("#PrivacyPolicy .titleInd").text("-");


		console.log('mobile privacy here');

	}

    

}else{


	if(!mobile){

		console.log('here for shipping');


		$(".policySection:first-of-type .polTitle").addClass('o100');
		$(".policySection:first-of-type .polCol_info").addClass('o100');	

		setTimeout(function(){
			var ph = $(".policySection:nth-of-type(1)").outerHeight(true);
			// var ph2 = ph * 1.05;
			$(".page-policies main").height(ph);
			console.log('height 1: ', ph);
		}, 300);//for some reason, doesn't calculate full height without slight time offset


	}else{

		var childBlock = $("#ShippingReturns").nextAll('.polBlock');


		$("#ShippingReturns").addClass('polBlock_open');
		gsap.to((childBlock), 0.99, {height:"auto", ease: Power4.easeOut});

		$("#ShippingReturns .titleInd").text("-");


		console.log('mobile shipping here');
	}


	
}

// if(window.location.href.contains("shipping") > -1){
// 	console.log('here for shipping');
// } else{
// 	console.log('here for privacy');
// }






// var polSectsLength = $(".policySection").length;

// console.log('sections: ', polSectsLength);


if(!mobile){

	$(".polCol_titles").click(function() {

		var thisTitle = $(this).find('.polTitle');
		var thisBlock = $(this).siblings('.polCol_info');

		var thisHeight = $(this).parent('.polMainCon').outerHeight(true);
		$(".page-policies main").height(thisHeight);


		$('.polTitle').removeClass('o100');
		thisTitle.addClass('o100');


		console.log('this block: ', thisHeight);


		$('.polCol_info').removeClass('o100');
		gsap.to(('.polCol_info'), 0.66, {opacity:0, x:-5, ease: Power4.easeOut});
		gsap.to((thisBlock), 0.66, {opacity:1, x:5, ease: Power4.easeOut});


	});


}else{

	$(".polCol_titles").click(function(e) {

		var currPolID = $(this).attr('id');
		var currPol = $("#" + currPolID);

		var	currBlock = $(this);
		var childBlock = $(this).nextAll('.polBlock');

		console.log(e.target);
		

		if(e.target.classList.contains("polBlock_open")){

			currPol.removeClass('polBlock_open');
			gsap.to((childBlock), 0.99, {height:"0", ease: Power4.easeOut});

			$("#" + currPolID + " .titleInd").text("+");

			console.log('has it');


		}else{

			currPol.addClass('polBlock_open');
			gsap.to((childBlock), 0.99, {height:"auto", ease: Power4.easeOut});

			$("#" + currPolID + " .titleInd").text("-");

			console.log('dont has it');



		}


		// console.log(childBlock);


	});


}



}


if(document.body.classList.contains('customers-login')){

	$('a[href="#recover"]').click(function() {
		gsap.to(('.loginBlock'), 0.88, {opacity:0, display:"none", y:20,  ease: Power4.easeOut});
		gsap.to(('.recoverBlock'), 0.88, {opacity:1, display:"block", y:0, delay:0.88, ease: Power4.easeOut});
	});

	$('a[href="#login"]').click(function() {
		gsap.to(('.recoverBlock'), 0.88, {opacity:0, display:"none", y:20,  ease: Power4.easeOut});
		gsap.to(('.loginBlock'), 0.88, {opacity:1, display:"block", y:0, delay:0.88, ease: Power4.easeOut});
	});

	// $('a[href="#recover"]').click(function() {
	// 	gsap.to(('.loginBlock'), 0.66, {opacity:0, display:"none", y:20, ease: Power4.easeOut});
	// 	gsap.to(('.recoverBlock'), 0.66, {opacity:1, display:"block", y:0, ease: Power4.easeOut});
	// });

	console.log('here here');
}

// if(document.body.classList.contains('customers-account')){

// $(".addressBtn, .addressLink, #deleteAddBtn").click( (e)=> {
// 	// e.preventDefault();
//     // window.location.href;
// });


// }

// if(window.location.href.indexOf("addresses") > -1){
// 	console.log('well here we are');
// 	// window.location.replace('https://the-sil-dev2022-01.myshopify.com/account');
//     // window.location.href;

// }


if(window.location.href.indexOf("return") > -1){

	var swap = ()=> {

		$("label[for=orderId] span").text("Order Number");
		$("label[for=email] span").text("Email/ZIP/Phone");

		console.log('swapped');
	
	}	

	


	setTimeout(swap, 2000);
		

}


if(document.body.classList.contains('customers-register')){


	$("#marketing").click(function() {

		$(this).toggleClass('toggOn');

		console.log('TOGGED');

	});

}




//----------------------------------------------BLOG POSTS

// if(document.body.classList.contains('article')){

// 	$(".article-template__content div, .article-template__content p").each(function(i){

// 		var curr = $(this);
// 		var kids = $(this).children().is("img");
// 		var neighborKids = $(this).next().children().is("img");

// 		if(kids && neighborKids){

// 			$(this).addClass("pairedIMG");
// 			$(this).next().addClass("pairedIMG");

// 			console.log("trip 1:", kids);



// 			// console.log('PAIR FOUND ------------------');
// 		}else if (kids.length > 1){

// 			console.log("trip 2:", kids);
			
// 		}else{
// 			$(this).addClass("regEl");
// 		}

// 		// console.log(curr, kids);
// 	});
// }


//----------------------------------------------BLOG POSTS

if(document.body.classList.contains('article')){

	$(".article-template__content div, .article-template__content p, .article-template__content span").each(function(i){

		var curr = $(this);
		var kids = $(this).find("img");
		var ta = $(this).css("text-align");
		
		// console.log('align is: ', ta);
		// console.log('kids is: ', kids);

		if(ta == "right" && kids.length == 1){

			$(this).addClass("bl_img_wrpr");
	
			$(this).attr("style", " ");

			// console.log('trip 1');

		}else if(ta == "right" && kids.length > 1){

			var secondKid = curr.find('img')[1];
			var skSrc = secondKid.currentSrc;
			// console.log('secondKid child', secondKid);
			// console.log('this: ', this);


			secondKid.remove();

			$(this).addClass("bl_img_wrpr");
	
			$(this).attr("style", " ");

			$(this).after( '<div class="bl_img_wrpr"><img src="' + skSrc + '"</div>');


			// console.log('trip 2');
		}else{
			$(this).addClass("regEl");
		}


		// if(kids && neighborKids){

		// 	$(this).addClass("pairedIMG");
		// 	$(this).next().addClass("pairedIMG");

		// 	console.log("trip 1:", kids);



		// 	// console.log('PAIR FOUND ------------------');
		// }else if (kids.length > 1){

		// 	console.log("trip 2:", kids);
			
		// }else{
		// 	$(this).addClass("regEl");
		// }

		// console.log(curr, kids);
	});
}

//------------------------------------------------------------------CART REDIRECT

// if(window.location.href.indexOf("cart") > -1){

// 	console.log('hey cart!');

// 	var initURL = window.location.href; 
// 	var strippedURL = initURL.slice(0, initURL.indexOf('/cart'));

// 	window.location.href = strippedURL; 

// 	// openCart();

// 	console.log('coming from cart page...');



// }


//------------------------------------------------------------------INITIATE

$(document).ready(function(){

	console.log('SIL JS HERE');
	lines();

});